<!-- @for re-creates the span whenever the value changes — that insertion/removal is what fires enter/leave; not `track current`, which NG0956 flags -->
@for (current of [value()]; track `${current}`) {
    <span animate.enter="enter" animate.leave="leave">{{ current ?? '—' }}</span>
}
